module.exports = __webpack_public_path__ + "img/智能消杀灯1.b31df0c6.png";